<template>
  <v-layout wrap class="pa-3">
    <v-flex xs12>
      Location:
      <span style="color: red" v-if="user.locationOne==null || user.locationOne==undefined">Not Set</span>
      <span v-else>{{user.locationOne.locationName}}</span>
      <v-btn color="btnColor" dark flat @click="locationModal('locationOne')">
        <v-icon>add</v-icon>Update Location
      </v-btn>
    </v-flex>

    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-toolbar color="primary" flat dense dark>
          <v-toolbar-title class="title">Add Operating Location</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <div class="location-div" v-for="(location, index) of places" v-bind:key="index">
                  <span>Selected Location:</span>
                  <span class="location-text">{{ location.formatted_address}}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="mapInput">
                <h2>Search a Location</h2>
                <label>
                  <gmap-autocomplete @place_changed="setPlace" :options="{fields: ['geometry', 'formatted_address', 'address_components']}"></gmap-autocomplete>
                  <!-- <v-btn @click="addMarker" flat color="btnColor">Add</v-btn> -->
                </label>
              </v-flex>

              <v-flex xs12 sm6>
                <v-btn small color="red" dark @click="reset">Reset Location</v-btn>
                <v-btn
                  color="btnColor"
                  class="right"
                  dark
                  small
                  @click="saveLocation()"
                  :loading="loader"
                >
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>

              <v-flex xs12>
                <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    @click="center=m.position"
                  ></gmap-marker>
                </gmap-map>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "LocationModal",
  computed: {
    ...mapGetters(["user"])
  },
  components: {},
  data() {
    return {
      dialog: false,
      location: null,
      locationType: null,
      loader: false,
      errorSnackbar: false,
      timeout: 4000,
      errorText: "You can only select one location!",
      center: { lat: -1.285355, lng: 36.791082 },
      markers: [],
      places: {},
      currentPlace: null
    };
  },
  mounted() {
    this.geolocate();
  },
  methods: {
    locationModal(locType) {
      this.locationType = locType;
      this.dialog = true;
    },
    // google maps
    setPlace(place) {
      if (this.places.length >= 1) {
        this.errorSnackbar = true;
        this.geolocate();
      } else {
        this.currentPlace = place;
        this.addMarker();
      }
    },
    reset() {
      this.places = [];
      this.markers = [];
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.place = this.currentPlace;
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    // end of google maps
    saveLocation() {
      const lat = this.place.geometry.location.lat();
      const lng = this.place.geometry.location.lng();
      const coordinates = [];
      coordinates.push(lat);
      coordinates.push(lng);
      const location = {
        type: "Point",
        coordinates: coordinates,
        locationName: this.place.formatted_address
      };
      
      let data;
      data = {
        locationOne: location
      }
      //dispatch
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.dialog = false;
        });
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>


<style scoped>
.mapInput input {
  border: 2px solid #a9a9a9;
  width: 350px;
}

.location-div {
  font-size: 20px;
}

.location-text {
  color: red;
}

.locationsList li {
  list-style: none;
  padding: 5px;
}
</style>
